<template>
  <v-dialog
    :value="isConfigurarSolicitanteDialogOpen"
    width="900px"
    persistent
  >
    <div v-if="!solicitanteId">
      <configurar-solicitante-card
        :solicitante-id="solicitanteId"
        :close-dialog="closeDialog"
      />
    </div>

    <div v-else>
      <v-tabs
        v-model="currentTab"
        show-arrows
        class="user-tabs"
        grow
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab.icon"
        >
          <v-icon
            size="20"
            class="me-3"
          >
            {{ tab.icon }}
          </v-icon>
          <span>{{ tab.title }}</span>
        </v-tab>

        <v-tab @click="closeDialog">
          <v-icon color="error">
            {{ icons.mdiCloseCircleOutline }}
          </v-icon>
        </v-tab>
      </v-tabs>

      <v-tabs-items
        id="user-tabs-content"
        v-model="currentTab"
      >
        <div style="min-height: 4px">
          <v-progress-linear
            v-if="loading"
            indeterminate
          />
        </div>

        <v-tab-item>
          <configurar-solicitante-card
            :solicitante-id="solicitanteId"
            :close-dialog="closeDialog"
            @refetch-data="$emit('refetch-data')"
          />
        </v-tab-item>

        <v-tab-item>
          <table-solicitante-atendimentos-list :items="atendimentos" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-dialog>
</template>

<script>
import { mdiForum, mdiCloseCircleOutline, mdiAccountSupervisor } from '@mdi/js'
import { ref, watchEffect } from '@vue/composition-api'
import ConfigurarSolicitanteCard from '@/views/solicitante/ConfigurarSolicitanteCard.vue'
import TableSolicitanteAtendimentosList from '@/views/solicitante/TableSolicitanteAtendimentosList.vue'
import ClienteService from '@/services/modules/ClienteService'

export default {
  components: {
    ConfigurarSolicitanteCard,
    TableSolicitanteAtendimentosList,
  },

  props: {
    isConfigurarSolicitanteDialogOpen: {
      type: Boolean,
      required: true,
    },
    solicitanteId: {
      type: Number,
      required: true,
    },
    closeDialog: {
      type: Function,
      required: true,
    },
  },

  setup(props) {
    const currentTab = ref(0)

    const atendimentos = ref([])
    const loading = ref(false)

    async function getAtendimentosSolicitante() {
      try {
        loading.value = true
        atendimentos.value = await ClienteService.getAtendimentosSolicitante(props.solicitanteId)
      } finally {
        loading.value = false
      }
    }
    watchEffect(() => {
      if (props.solicitanteId) {
        getAtendimentosSolicitante()
      }
    })

    watchEffect(() => {
      if (props.isConfigurarSolicitanteDialogOpen) {
        currentTab.value = 0
      }
    })

    const tabs = [
      { icon: mdiAccountSupervisor, title: 'Solicitante' },
      { icon: mdiForum, title: 'Atendimentos' },
    ]

    return {
      currentTab,
      atendimentos,
      loading,
      tabs,
      icons: {
        mdiCloseCircleOutline,
      },
    }
  },
}
</script>
